'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import updateQueryParam from '@/client/utils/updateQueryParam/updateQueryParam';
import IconButton from '@/external/components/IconButton';
import SoftwarePlate from '@/external/icons/SoftwarePlate';
import SoftwareSorting from '@/external/icons/SoftwareSorting';
import TextListView from '@/external/icons/TextListView';

type Props = {
  title: string;
  subtitle: string;
  isListView: boolean;
  newThumbsEnabled?: boolean;
  casinoBoostSettings?: string;
  handle?: string;
};

const MobileFirstRow: FC<Props> = ({
  children,
  title,
  subtitle,
  isListView,
  newThumbsEnabled,
  casinoBoostSettings,
  handle,
}) => {
  const router = useRouter();
  const [showFilters, setShowFilters] = useState(false);

  const handleShowGridClick = () => {
    router.push(
      updateQueryParam(
        window.location.href,
        'mobileFilterView',
        isListView ? undefined : 'list',
      ),
    );
  };

  const handleFilterClick = () => setShowFilters((isVisible) => !isVisible);
  const hideSorting = handle === 'favourite' || handle === 'recents';
  return (
    <div className="relative grid grid-cols-minmax gap-4 md:mb-2.5 lg:grid-flow-col lg:justify-between">
      <div className="grid grid-flow-col grid-cols-minmax gap-2 p-1">
        <div className="grid grid-cols-minmax gap-1">
          <h1 className="z-2 self-end text-moon-24 text-bulma">{title}</h1>
          {subtitle && (
            <p className="text-moon-14 text-trunks sm:text-moon-16">
              {subtitle}
            </p>
          )}
        </div>
        {!newThumbsEnabled && (
          <IconButton
            data-testid="filter-button"
            size="xs"
            onClick={handleShowGridClick}
            variant="tertiary"
            className="h-10 w-10 rounded-moon-i-xs"
          >
            {isListView ? <TextListView /> : <SoftwarePlate />}
          </IconButton>
        )}
        {(!casinoBoostSettings || hideSorting) && (
          <IconButton
            data-testid="filter-button"
            size="xs"
            onClick={handleFilterClick}
            variant="tertiary"
            className="h-10 w-10 rounded-moon-i-xs text-moon-32 text-bulma"
          >
            <SoftwareSorting />
          </IconButton>
        )}
      </div>
      {showFilters && children}
    </div>
  );
};

export default MobileFirstRow;
